<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="main_content">
          <div class="items_wrap">
            <div class="item_tit">产品</div>
            <div class="item_options">
              <span @click="handleToRouter('/production/1')">上下游协同管理</span>
              <span @click="handleToRouter('/production/dealer-auth')">经销商授权管理</span>
              <span @click="handleToRouter('/production/dealer-manage')">经销商经营管理系统</span>
              <span @click="handleToRouter('/production/surgery-track')">高值耗材手术跟台管理</span>
              <span @click="handleToRouter('/production/data-analysis')">数据分析管理</span>
              <span @click="handleToRouter('/production/dealer-quality')">经销商经营质量管理系统</span>
              <span @click="handleToRouter('/production/ai-operation')">AI智能运营管理</span>
            </div>
          </div>
          <div class="items_wrap">
            <div class="item_tit">相关动态</div>
            <div class="item_options">
              <span @click="handleToRouter('/fournav/1')">行业报告</span>
            </div>
          </div>
          <div class="items_wrap contact_wrap">
            <div class="item_tit">联系我们</div>
            <div class="item_options">
              <span class="city-link" @click="handleToRouter('/about')">杭州</span>
              <div class="massage_show">
                <p>{{ cityInfomation[0].phone }}</p>
                <p>{{ cityInfomation[0].eamil }}</p>
                <p>{{ cityInfomation[0].address }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="qrcode_section">
          <div class="items_wrap">
            <div class="item_tit">服务号</div>
            <div class="item_options">
              <img src="@/assets/img/fuwuhao.jpg" alt="" />
              <span>柳叶云</span>
            </div>
          </div>
          <div class="items_wrap">
            <div class="item_tit">小程序</div>
            <div class="item_options">
              <img src="@/assets/img/xiaochengxu.png" alt="" />
              <span>柳叶云</span>
            </div>
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <span>友情链接:</span>
        <a href="https://www.nmpa.gov.cn/">国家药品监督管理局</a>
        <p class="beian-info">
          <!--Copyright ©2020 云逸创造 . All Rights Reserved . 浙ICP备15031491号-1
          浙公网安备 33010802005636号-->
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2024140855号-1</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cityInfomation: [
        {
          phone: '0571-89055898',
          eamil: '',
          address: '浙江省杭州市余杭区五常街道衢海大厦3幢201',
        }
      ],
      showCity: 0,
    }
  },
  methods: {
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 40PX;
    
    .bottom_container {
      width: 90%;
      max-width: 1200PX;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding-bottom: 60PX;
      border-bottom: solid #363636 2PX;
      gap: 40PX;
      
      @media screen and (max-width: 992PX) {
        flex-direction: column;
      }

      .main_content {
        display: flex;
        flex-wrap: wrap;
        gap: 40PX;
        
        @media screen and (max-width: 992PX) {
          gap: 20PX;
        }
        
        .contact_wrap {
          min-width: 300PX;
          @media screen and (max-width: 768PX) {
            min-width: 100%;
          }
        }
      }

      .qrcode_section {
        display: flex;
        gap: 20PX;
        align-items: flex-start;
        
        @media screen and (max-width: 992PX) {
          justify-content: flex-start;
          margin-top: 20PX;
        }
        
        @media screen and (max-width: 576PX) {
          flex-direction: column;
        }
      }

      .items_wrap {
        .item_tit {
          font-size: 22PX;
          margin-bottom: 20PX;
          text-align: left;
          
          @media screen and (max-width: 768PX) {
            font-size: 18PX;
            margin-bottom: 15PX;
          }
        }
        
        .item_options {
          display: flex;
          flex-direction: column;
          
          img {
            width: 120PX;
            height: 120PX;
            object-fit: contain;
            background-color: #fff;
            padding: 5PX;
            border-radius: 4PX;
            
            @media screen and (max-width: 768PX) {
              width: 100PX;
              height: 100PX;
            }
          }
          
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16PX;
            margin-top: 15PX;
            text-align: left;
            cursor: pointer;
            
            &:hover {
              font-weight: bold;
            }
            
            @media screen and (max-width: 768PX) {
              font-size: 14PX;
              margin-top: 10PX;
            }
          }
          
          .city-link {
            color: hsla(0, 0%, 100%, 0.5);
            &:hover {
              color: #fff !important;
            }
          }
          
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15PX;
            margin-top: 20PX;
            
            p {
              margin-top: 15PX;
              
              @media screen and (max-width: 768PX) {
                font-size: 13PX;
                margin-top: 10PX;
              }
            }
          }
        }
      }
    }
    
    .navigate_wrap {
      width: 90%;
      max-width: 1200PX;
      margin: 0 auto;
      margin-top: 40PX;
      padding-bottom: 15PX;
      display: flex;
      flex-wrap: wrap;
      gap: 10PX;
      
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16PX;
        margin-right: 20PX;
        text-decoration: none;
        
        @media screen and (max-width: 768PX) {
          font-size: 14PX;
          margin-right: 15PX;
        }
      }
      
      span {
        color: #fff;
        font-size: 18PX;
        margin-right: 20PX;
        
        @media screen and (max-width: 768PX) {
          font-size: 16PX;
          margin-right: 15PX;
        }
      }
      
      p {
        width: 100%;
        font-size: 14PX;
        color: #4e5557;
        margin-top: 20PX;
      }
      
      .beian-info {
        width: 100%;
        text-align: center;
        margin-top: 20PX;
        
        a {
          color: #4e5557;
          font-size: 14PX;
          text-decoration: none;
          margin-right: 0;
          
          &:hover {
            color: #fff;
          }
          
          @media screen and (max-width: 768PX) {
            font-size: 12PX;
          }
        }
      }
    }
  }
}
</style>